import { render, staticRenderFns } from "./VLogos.vue?vue&type=template&id=6e8aa6ee&"
import script from "./VLogos.vue?vue&type=script&lang=js&"
export * from "./VLogos.vue?vue&type=script&lang=js&"
import style0 from "./VLogos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports